<template>
  <div>
    <NavBar />
    <div class="container main-container">
      <h3>Nuestras Tiendas</h3>
      <GmapMap
        :center="{ lat: latitude, lng: longitude }"
        :zoom="zoom"
        map-type-id="roadmap"
        style="width: 100%; height: 450px"
        :options="{
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          mapTypeControl: false
        }"
      >
        <GmapMarker
          :key="index"
          v-for="(m, index) in $store.state.markers"
          :position="{ lat: m.position.lat, lng: m.position.lng }"
          :clickable="true"
          @click="onClick(m)"
        />
      </GmapMap>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";

export default {
  name: "Map",
  created() {
    this.getLocations()
  },
  methods: {
    onClick: function(point) {
      this.$dialog.alert(
        {
          title: point.label,
          body: point.address
        },
        {
          okText: "Continuar",
          html: false
        }
      );
    },
    getLocations: function() {
      this.$Progress.start();
      let url = this.$store.state.connection.url;
      /*
      Why is the POST method being used instead of a GET request?
      the XMLHttpRequest#send method does not send a body when performing
      a GET request, and odoo's json request handling throws a 400 error
      when not specifying a body in json requests.
      */
      this.$http
        .post(url + "stores/location", {
          body: {}
        })
        .then(result => {
          this.$Progress.finish()
          let locations = result.body.result.locations
          this.$store.commit("updateStoreLocations", locations);
        })
        .catch(err => {
          console.log(err);
          this.$Progress.finish();
        });

    },
  },
  components: {
    NavBar
  },
  data: function() {
    return {
      latitude: -16.4063461,
      longitude: -71.5556761,
      zoom: 12
    };
  }
};
</script>

<style scoped>
h3 {
  width: 100%;
  text-align: left;
  font-size: 25px;
}
</style>
